import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatAuthError } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { LogIn, Wrench } from "lucide-react";

export default function TechLogin() {
  const { techLogin } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!username || !password) {
      toast.error("ID Armada & password wajib diisi");
      return;
    }
    setBusy(true);
    try {
      await techLogin(username, password);
      toast.success("Login berhasil");
      navigate("/tech/rekap", { replace: true });
    } catch (err) {
      toast.error(formatAuthError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A0E1A] via-[#0F1729] to-[#0A0E1A] flex items-center justify-center px-4" data-testid="tech-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-[#E65100] to-[#F57C00] mb-4 shadow-xl shadow-orange-900/40">
            <Wrench className="w-8 h-8 text-white" strokeWidth={2} />
          </div>
          <h1 className="font-['Manrope'] font-bold text-2xl text-white tracking-tight">GLOBAL AC</h1>
          <div className="text-[11px] uppercase tracking-[0.2em] text-orange-300/80 mt-1.5 font-semibold">
            Dashboard Armada
          </div>
        </div>

        <form onSubmit={submit} className="space-y-3 bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-2xl">
          <div>
            <label className="block text-[10px] uppercase tracking-widest text-white/60 font-bold mb-1.5">ID Armada</label>
            <Input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Contoh: armadaga09 (tanpa @)"
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              className="rounded-lg bg-white/10 border-white/20 text-white placeholder:text-white/30 focus:bg-white/20 h-11"
              data-testid="tech-login-username-input"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-widest text-white/60 font-bold mb-1.5">Password</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              className="rounded-lg bg-white/10 border-white/20 text-white placeholder:text-white/30 focus:bg-white/20 h-11"
              data-testid="tech-login-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={busy}
            className="w-full h-11 bg-gradient-to-r from-[#E65100] to-[#F57C00] hover:opacity-90 rounded-lg font-semibold gap-2"
            data-testid="tech-login-submit-btn"
          >
            <LogIn className="w-4 h-4" />
            {busy ? "Memproses…" : "Masuk"}
          </Button>
          <div className="text-center text-[10px] text-white/40 pt-2">
            Kredensial diberikan oleh admin. Hubungi kantor jika lupa password.
          </div>
        </form>
      </div>
    </div>
  );
}
